/*
 * Copyright (c) 2022, Salesforce, Inc.
 * SPDX-License-Identifier: BSD-3-Clause
 *
 * Override: no auto-create POST; fetch only for registered shoppers (not SLAS guest).
 */

import {useProductLists, WISH_LIST_TYPE} from './use-product-lists'

/**
 * @param {{ listId?: string, enabled?: boolean }} [options]
 */
export const useWishList = ({listId = '', enabled: enabledOption} = {}) => {
    const {wishList, allLists, isLoading, error, refetch} = useProductLists({
        enabled: enabledOption
    })

    const wishLists = allLists.filter((list) => list.type === WISH_LIST_TYPE)
    const currentWishlist = wishLists.find((list) => list.id === listId)

    return {
        data: !listId ? wishList ?? wishLists[0] : currentWishlist,
        isLoading,
        error,
        refetch
    }
}
